import { create } from 'zustand';
import {
  getFundamentalDataAction,
  getWatchDataAction,
  postChangedFormulaAction,
} from './action';
import {
  CommodityItemType,
  FundamentalDataType,
  FundamentalWatchType,
  WatchFilterType,
} from 'typings/fundamental.type';
import { FUNDAMENTAL_INITIAL_DATA } from 'utils/fundamental.util';

type FundamentalType = {
  reset: () => void;
  fundamentalDataLoading: boolean;
  fundamentalDataError: boolean;
  fundamentalData: FundamentalDataType;
  fundamentalDefaultData: FundamentalDataType;
  getFundamentalDataAction: (
    securityId: string,
    fundamentalId?: number | string,
  ) => Promise<void>;

  watchError: boolean;
  watchData: FundamentalWatchType[];
  getWatchDataAction: () => Promise<void>;

  changeFormulaLoading: boolean;
  changeFormulaError: boolean;
  postChangedFormulaAction: (
    data: {
      id: number;
      slug: string;
      value: string | number;
    },
    unit: string,
    changedValues: CommodityItemType[],
  ) => Promise<void>;

  watchFilters: WatchFilterType;
  setWatchFiltersAction: (body: WatchFilterType) => void;
};

const initialState = {
  fundamentalDataLoading: false,
  fundamentalDataError: false,
  fundamentalData: FUNDAMENTAL_INITIAL_DATA,
  fundamentalDefaultData: FUNDAMENTAL_INITIAL_DATA,
  watchError: false,
  watchData: null,
  watchFilters: null,
  changeFormulaLoading: false,
  changeFormulaError: false,
};

const useFundamentalStore = create<FundamentalType>((set) => ({
  ...initialState,
  reset: (): void => set(initialState),
  getWatchDataAction: async (): Promise<void> => getWatchDataAction(set),
  setWatchFiltersAction: (watchFilters): void => set({ watchFilters }),
  getFundamentalDataAction: async (securityId, fundamentalId): Promise<void> =>
    getFundamentalDataAction(set, securityId, fundamentalId),
  postChangedFormulaAction: async (data, unit, changedValues): Promise<void> =>
    postChangedFormulaAction(set, data, unit, changedValues),
}));

export default useFundamentalStore;
